module.exports = __webpack_public_path__ + "assets/4.png";


//////////////////
// WEBPACK FOOTER
// ./images/4.png
// module id = 699
// module chunks = 0